import React from 'react';
import { DateUtility } from '../../utils/dateUtility';

const GolfTimeConverter = ({ timeValue }) => {
  const isValidDateString = (value) => {
    if (typeof value !== 'string') return false;
    const isoString = value.replace(' ', 'T') + 'Z';
    const date = new Date(isoString);
    return !isNaN(date.getTime());
  };

  const formattedTime = isValidDateString(timeValue)
    ? DateUtility?.FormatTime(timeValue?.replace(' ', 'T') + 'Z')
    : timeValue;

  return <td>{formattedTime}</td>;
};

export default GolfTimeConverter;
